import { useQuery } from '@tanstack/react-query';
import * as adminApi from '@/api/admin';
import type { AdminUserQuery } from '@/api/admin';

// ═══════════════════════════════════════════════════════════════════
// QUERY KEYS
// ═══════════════════════════════════════════════════════════════════

export const adminUserKeys = {
  all: ['admin', 'users'] as const,
  lists: () => [...adminUserKeys.all, 'list'] as const,
  list: (query?: AdminUserQuery) => [...adminUserKeys.lists(), query] as const,
};

// ═══════════════════════════════════════════════════════════════════
// QUERIES
// ═══════════════════════════════════════════════════════════════════

/**
 * Hook to fetch all accounts (paginated, searchable, filtered by role).
 * Keeps the previous page on screen while the next one loads.
 */
export function useAdminUsers(query?: AdminUserQuery) {
  return useQuery({
    queryKey: adminUserKeys.list(query),
    queryFn: () => adminApi.getAdminUsers(query),
    placeholderData: (previous) => previous,
  });
}
